import {useRef} from "react";

export function useFormRefManager(){
    const formRefs = useRef(new Map<string, any>());

    function removeBrokenRefs(){
        const entries = Array.from(formRefs.current.entries());

        for (let entry of entries) {
            if (entry[1] === null || entry[1] === undefined){
                formRefs.current.delete(entry[0]);
            }
        }
    }

    function clear(){
        formRefs.current = new Map();
    }

    function add(internalId: string, ref: any){
        formRefs.current.set(internalId, ref);
    }

    function remove(internalId: string){
        formRefs.current.delete(internalId);
    }

    return {
        add,
        remove,
        clear,
        getFormRefs: () => {
            removeBrokenRefs();
            return formRefs.current;
        }
    }
}